import React from 'react';

import { EventMykissCtaButtonClicked } from '../../../interfaces/events';
import { CTAButton } from '../../Clickables/Buttons/CTAButton/CTAButton';
import { LockIcon } from '../../Icons/LockIcon';
import { Text } from '../../Text/Text';

interface ICatchMapBodyyProps {
  onClick?: () => void;
  isCtaVisible: boolean;
  isPrivate: boolean;
  message: string;
  source: EventMykissCtaButtonClicked['properties']['source'];
}

export const CatchMapBody = ({
  onClick,
  isCtaVisible,
  isPrivate,
  message,
  source,
}: ICatchMapBodyyProps) => (
  <div className="col-start-1 row-start-1 flex flex-col items-center justify-center">
    {isCtaVisible ? (
      <CTAButton onClick={onClick} type="pro" variant="buttonPro" source={source}>
        Unlock catch position
      </CTAButton>
    ) : (
      <div className="flex">
        {isPrivate && (
          <div className="text-sea-foam mr-1">
            <LockIcon height="17" width="17" />
          </div>
        )}
        <Text variant="sm" className="text-sea-foam mb-0">
          {message}
        </Text>
      </div>
    )}
  </div>
);
